import React from 'react'
// import Hex from "./Hex"
import "./ExperienceDisplay.css"

const ExperienceDisplay = ({img, name, info, timeFrame, tech}) => {
    return (
        <div className="Exp-display">
            
            <div className="hex">
                <div className="hex-background">
                    <img src={img} alt="myself-test"/>
                </div>
            </div>
            <div className="exp-info">
                <h3>{name}</h3>
                <p>{info}</p>
                <p>{timeFrame}</p>
                <p>{tech}</p>
            </div>
        </div>
    )
}

export default ExperienceDisplay
